import { APP_INITIALIZER, LOCALE_ID, NgModule } from '@angular/core';
import {
  BrowserModule,
  HAMMER_GESTURE_CONFIG,
  HammerGestureConfig,
} from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { IonicModule, IonicRouteStrategy, isPlatform } from '@ionic/angular';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { registerLocaleData } from '@angular/common';
import localeIt from '@angular/common/locales/it';

registerLocaleData(localeIt, 'it');

import { IonicStorageModule } from '@ionic/storage-angular';

import { FullScreenImageComponentModule } from './modules/full-screen-image/components/full-screen-image/full-screen-image.module';

import { HammerModule } from '@angular/platform-browser';
import { StripeService } from './modules/pay/services/stripe/stripe.service';

export function initializeStripe(stripeService: StripeService) {
  return () => stripeService.initialize();
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    HammerModule,
    IonicModule.forRoot({
      innerHTMLTemplatesEnabled: true,
      // scrollAssist OFF: la tastiera è già gestita dal resize (Android resize:'ionic',
      // iOS resize nativo) che rimpicciolisce ion-content. scrollAssist faceva uno scroll
      // extra che, su input già in cima, li spingeva oltre il bordo alto dello schermo.
      scrollAssist: false,
      scrollPadding: false,
      mode:
        isPlatform('android') || isPlatform('phablet') || isPlatform('tablet')
          ? 'md'
          : 'ios',
    }),
    AppRoutingModule,
    IonicStorageModule.forRoot(),
    FullScreenImageComponentModule,
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'it' },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeStripe,
      deps: [StripeService],
      multi: true,
    },
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    {
      provide: HAMMER_GESTURE_CONFIG,
      useClass: HammerGestureConfig,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
